










import { Component, Vue } from 'vue-property-decorator';
import TheHeader from "@/components/TheHeader";
import TheHero from "@/components/TheHero";
import ThePillars from "@/components/ThePillars";
import TheStages from "@/components/TheStages";
import TheContact from "@/components/TheContact";
import MenuItem from '@/components/TheHeader/MenuItem';
import menuItems from '@/menuItems';

@Component({
  components: {
    TheHeader,
    TheHero,
    ThePillars,
    TheStages,
    TheContact,
  },
})
export default class App extends Vue {
  menuItems: MenuItem[] = [];

  created() {
    this.setMenuItems();
  }

  setMenuItems() {
    // @ts-ignore
    this.menuItems = menuItems.map(item => ({ href: item.href, label: this.$c(item.term) as string }))
  }
}
